// extracted by mini-css-extract-plugin
export var box = "_3b-0";
export var check = "_3b-1";
export var checkboxButton = "_3b-6";
export var checkboxGroup = "_3b-5";
export var disabled = "_3b-7";
export var ghost = "_3b-9";
export var input = "_3b-2";
export var label = "_3b-4";
export var normal = "_3b-8";
export var uncheck = "_3b-3";